module.exports = __webpack_public_path__ + "assets/fonts/FWDCircularWeb-Book.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fwd/fonts/FWDCircularWeb-Book.woff
 ** module id = 1105
 ** module chunks = 0
 **/